import BodyRow, { IBodyRowProps } from './BodyRow';
import BodyRowPure from './BodyRowPure';

export default BodyRow;
export { BodyRowPure };
export type { IBodyRowProps };
